import React from 'react';
import styled from 'styled-components';
import IconLocalShipping from '@tvg/fuse-icons/lib/LocalShipping';
import { gridConfig, Modal } from '@tvg/fuse-design';
import { DeliveryAndReturnsDialogProps } from '../DeliveryAndReturnsProps';

const Body = styled.div`
  color: var(--color-font-paragraph);
  font-weight: var(--font-weight-paragraph);
  font-size: var(--font-size-1);
  line-height: var(--font-line-height-1);

  h3,
  h4,
  h5 {
    color: var(--color-font-heading);
  }

  h3 {
    font-size: var(--font-size-3);
    line-height: var(--font-line-height-3);
    margin-bottom: var(--spacing-space16);
  }

  h4,
  h5 {
    font-size: var(--font-size-1);
    line-height: var(--font-line-height-1);
    margin-bottom: var(--spacing-space16);
  }

  h5 {
    margin-bottom: var(--spacing-space8);
  }

  p {
    margin-bottom: var(--spacing-global-space4);
    font-size: var(--font-size-1);
  }

  ul {
    list-style: disc;
    padding-left: var(--spacing-space16);
    margin-bottom: var(--spacing-space16);
  }

  li:not(:last-child) {
    margin-bottom: var(--spacing-space4);
  }

  dl {
    display: grid;
    grid-template-columns: 50% 50%;
    border: 1px solid var(--color-greys-grey4);
    margin-bottom: var(--spacing-global-space4);
    margin-top: var(--spacing-space8);

    > * {
      margin: 0;
      padding: var(--spacing-space16);
    }

    dt {
      border-right: 1px solid var(--color-greys-grey4);
      font-weight: bold;
      color: var(--color-font-heading);
    }

    dt,
    dd {
      padding: var(--spacing-global-space4) var(--spacing-global-space5);
      font-size: var(--font-size-m1);
    }

    dt:nth-child(4n + 1),
    dd:nth-child(4n + 2) {
      border-bottom: 1px solid var(--color-greys-grey4);
    }

    dt:nth-child(3),
    dd:nth-child(4) {
      background-color: var(--color-greys-grey2);
    }
  }

  .delivery-return-info {
    margin-bottom: var(--spacing-global-space3);
    font-size: var(--font-size-1);
    line-height: var(--font-line-height-1);
    color: var(--color-font-heading);
  }

  .bottom-text-model {
    font-size: var(--font-size-m1);
    line-height: var(--font-line-height-m1);
  }

  @media (max-width: ${gridConfig.xs.maxWidth}) {
    dt,
    dd {
      font-size: var(--font-size-m2) !important;
      padding: var(--spacing-global-space3) !important;
      line-height: var(--font-line-height-m2) !important;
    }
  }
  a {
    text-decoration: underline;
    cursor: pointer;

    color: var(--color-font-paragraph);
    font-weight: var(--font-weight-paragraph);
    font-size: var(--font-size-1);
    line-height: var(--font-line-height-1);

    &:hover {
      color: var(--color-brand-mid) !important;
    }

    &:visited {
      color: var(--color-font-paragraph);
    }
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;

const BrandLogo = styled.img`
  margin-bottom: var(--spacing-global-space4);
  height: 48px;
  max-height: 48px;
  display: block;
`;

const StyledModal = styled(Modal)`
  .fuse-modal__footer {
    display: none;
  }
  .fuse-modal__body {
    border-radius: 0 0 6px 6px;
    padding: var(--spacing-global-space7) var(--spacing-global-space7) var(--spacing-global-space7);
  }

  @media (max-width: ${gridConfig.m.maxWidth}) {
    .fuse-modal__body {
      padding: var(--spacing-global-space7) var(--spacing-global-space6) var(--spacing-global-space8);
    }
  }

  @media (max-width: ${gridConfig.xs.maxWidth}) {
    .fuse-modal__body {
      padding: var(--spacing-global-space6) var(--spacing-global-space5) var(--spacing-global-space7);
    }
  }
`;

function DeliveryAndReturnsDialog(props: DeliveryAndReturnsDialogProps) {
  const { body, brand, brandLogoUrl, heading, onClose, open } = props;

  return (
    <StyledModal
      dataTestId="delivery-and-returns-dialog"
      headerIcon={<IconLocalShipping />}
      name="delivery-and-returns-dialog"
      onClose={onClose}
      open={open}
      srLabelCloseButton="Close delivery and returns dialog"
      title={heading}
      zIndex="20"
    >
      {brand && brandLogoUrl && (
        <BrandLogo
          src={brandLogoUrl}
          width="auto"
          alt={`${brand} brand logo`}
          data-testid="delivery-and-returns-brand-logo"
        />
      )}
      <Body data-testid="delivery-and-returns-dialog-body" dangerouslySetInnerHTML={{ __html: body }} />
    </StyledModal>
  );
}

export default DeliveryAndReturnsDialog;
